import type { WeekSelectorProps } from './WeekSelector';

export const mockWeeks: WeekSelectorProps['weeks'] = {
  '1': [
    {
      academicWeekNumber: 1,
      calendarWeekNumber: 36,
      isBlocked: false,
      period: 1,
      startDate: '2026-08-31T00:00:00.000Z',
      endDate: '2026-09-04T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 2,
      calendarWeekNumber: 37,
      isBlocked: false,
      period: 1,
      startDate: '2026-09-07T00:00:00.000Z',
      endDate: '2026-09-11T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 3,
      calendarWeekNumber: 38,
      isBlocked: false,
      period: 1,
      startDate: '2026-09-14T00:00:00.000Z',
      endDate: '2026-09-18T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 4,
      calendarWeekNumber: 39,
      isBlocked: false,
      period: 1,
      startDate: '2026-09-21T00:00:00.000Z',
      endDate: '2026-09-25T23:59:59.000Z',
      weekNumber: 4,
    },
    {
      academicWeekNumber: 5,
      calendarWeekNumber: 40,
      isBlocked: false,
      period: 1,
      startDate: '2026-09-28T00:00:00.000Z',
      endDate: '2026-10-02T23:59:59.000Z',
      weekNumber: 5,
    },
    {
      academicWeekNumber: 6,
      calendarWeekNumber: 41,
      isBlocked: false,
      period: 1,
      startDate: '2026-10-05T00:00:00.000Z',
      endDate: '2026-10-09T23:59:59.000Z',
      weekNumber: 6,
    },
    {
      academicWeekNumber: 7,
      calendarWeekNumber: 42,
      isBlocked: false,
      period: 1,
      startDate: '2026-10-12T00:00:00.000Z',
      endDate: '2026-10-16T23:59:59.000Z',
      weekNumber: 7,
    },
    {
      academicWeekNumber: 8,
      calendarWeekNumber: 43,
      isBlocked: false,
      period: 1,
      startDate: '2026-10-19T00:00:00.000Z',
      endDate: '2026-10-23T23:59:59.000Z',
      weekNumber: 8,
    },
  ],
  '2': [
    {
      academicWeekNumber: 9,
      calendarWeekNumber: 44,
      isBlocked: false,
      period: 2,
      startDate: '2026-10-26T00:00:00.000Z',
      endDate: '2026-10-30T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 10,
      calendarWeekNumber: 45,
      isBlocked: false,
      period: 2,
      startDate: '2026-11-02T00:00:00.000Z',
      endDate: '2026-11-06T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 11,
      calendarWeekNumber: 46,
      isBlocked: false,
      period: 2,
      startDate: '2026-11-09T00:00:00.000Z',
      endDate: '2026-11-13T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 12,
      calendarWeekNumber: 47,
      isBlocked: false,
      period: 2,
      startDate: '2026-11-16T00:00:00.000Z',
      endDate: '2026-11-20T23:59:59.000Z',
      weekNumber: 4,
    },
    {
      academicWeekNumber: 13,
      calendarWeekNumber: 48,
      isBlocked: false,
      period: 2,
      startDate: '2026-11-23T00:00:00.000Z',
      endDate: '2026-11-27T23:59:59.000Z',
      weekNumber: 5,
    },
    {
      academicWeekNumber: 14,
      calendarWeekNumber: 49,
      isBlocked: false,
      period: 2,
      startDate: '2026-11-30T00:00:00.000Z',
      endDate: '2026-12-04T23:59:59.000Z',
      weekNumber: 6,
    },
    {
      academicWeekNumber: 15,
      calendarWeekNumber: 50,
      isBlocked: false,
      period: 2,
      startDate: '2026-12-07T00:00:00.000Z',
      endDate: '2026-12-11T23:59:59.000Z',
      weekNumber: 7,
    },
    {
      academicWeekNumber: 16,
      calendarWeekNumber: 51,
      isBlocked: false,
      period: 2,
      startDate: '2026-12-14T00:00:00.000Z',
      endDate: '2026-12-18T23:59:59.000Z',
      weekNumber: 8,
    },
  ],
  '3': [
    {
      academicWeekNumber: 19,
      calendarWeekNumber: 1,
      isBlocked: false,
      period: 3,
      startDate: '2027-01-04T00:00:00.000Z',
      endDate: '2027-01-08T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 20,
      calendarWeekNumber: 2,
      isBlocked: false,
      period: 3,
      startDate: '2027-01-11T00:00:00.000Z',
      endDate: '2027-01-15T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 21,
      calendarWeekNumber: 3,
      isBlocked: false,
      period: 3,
      startDate: '2027-01-18T00:00:00.000Z',
      endDate: '2027-01-22T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 22,
      calendarWeekNumber: 4,
      isBlocked: false,
      period: 3,
      startDate: '2027-01-25T00:00:00.000Z',
      endDate: '2027-01-29T23:59:59.000Z',
      weekNumber: 4,
    },
  ],
  '4': [
    {
      academicWeekNumber: 23,
      calendarWeekNumber: 5,
      isBlocked: false,
      period: 4,
      startDate: '2027-02-01T00:00:00.000Z',
      endDate: '2027-02-05T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 24,
      calendarWeekNumber: 6,
      isBlocked: false,
      period: 4,
      startDate: '2027-02-08T00:00:00.000Z',
      endDate: '2027-02-12T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 25,
      calendarWeekNumber: 7,
      isBlocked: false,
      period: 4,
      startDate: '2027-02-15T00:00:00.000Z',
      endDate: '2027-02-19T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 26,
      calendarWeekNumber: 8,
      isBlocked: false,
      period: 4,
      startDate: '2027-02-22T00:00:00.000Z',
      endDate: '2027-02-26T23:59:59.000Z',
      weekNumber: 4,
    },
    {
      academicWeekNumber: 27,
      calendarWeekNumber: 9,
      isBlocked: false,
      period: 4,
      startDate: '2027-03-01T00:00:00.000Z',
      endDate: '2027-03-05T23:59:59.000Z',
      weekNumber: 5,
    },
    {
      academicWeekNumber: 28,
      calendarWeekNumber: 10,
      isBlocked: false,
      period: 4,
      startDate: '2027-03-08T00:00:00.000Z',
      endDate: '2027-03-12T23:59:59.000Z',
      weekNumber: 6,
    },
    {
      academicWeekNumber: 29,
      calendarWeekNumber: 11,
      isBlocked: false,
      period: 4,
      startDate: '2027-03-15T00:00:00.000Z',
      endDate: '2027-03-19T23:59:59.000Z',
      weekNumber: 7,
    },
    {
      academicWeekNumber: 30,
      calendarWeekNumber: 12,
      isBlocked: false,
      period: 4,
      startDate: '2027-03-22T00:00:00.000Z',
      endDate: '2027-03-26T23:59:59.000Z',
      weekNumber: 8,
    },
  ],
  '5': [
    {
      academicWeekNumber: 31,
      calendarWeekNumber: 13,
      isBlocked: false,
      period: 5,
      startDate: '2027-03-29T00:00:00.000Z',
      endDate: '2027-04-02T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 32,
      calendarWeekNumber: 14,
      isBlocked: false,
      period: 5,
      startDate: '2027-04-05T00:00:00.000Z',
      endDate: '2027-04-09T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 33,
      calendarWeekNumber: 15,
      isBlocked: false,
      period: 5,
      startDate: '2027-04-12T00:00:00.000Z',
      endDate: '2027-04-16T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 34,
      calendarWeekNumber: 16,
      isBlocked: false,
      period: 5,
      startDate: '2027-04-19T00:00:00.000Z',
      endDate: '2027-04-23T23:59:59.000Z',
      weekNumber: 4,
    },
    {
      academicWeekNumber: 35,
      calendarWeekNumber: 17,
      isBlocked: false,
      period: 5,
      startDate: '2027-04-26T00:00:00.000Z',
      endDate: '2027-04-30T23:59:59.000Z',
      weekNumber: 5,
    },
    {
      academicWeekNumber: 36,
      calendarWeekNumber: 18,
      isBlocked: true,
      period: 5,
      startDate: '2027-05-03T00:00:00.000Z',
      endDate: '2027-05-07T23:59:59.000Z',
      weekNumber: 6,
    },
    {
      academicWeekNumber: 37,
      calendarWeekNumber: 19,
      isBlocked: false,
      period: 5,
      startDate: '2027-05-10T00:00:00.000Z',
      endDate: '2027-05-14T23:59:59.000Z',
      weekNumber: 7,
    },
    {
      academicWeekNumber: 38,
      calendarWeekNumber: 20,
      isBlocked: false,
      period: 5,
      startDate: '2027-05-17T00:00:00.000Z',
      endDate: '2027-05-21T23:59:59.000Z',
      weekNumber: 8,
    },
    {
      academicWeekNumber: 39,
      calendarWeekNumber: 21,
      isBlocked: false,
      period: 5,
      startDate: '2027-05-24T00:00:00.000Z',
      endDate: '2027-05-28T23:59:59.000Z',
      weekNumber: 9,
    },
  ],
  '6': [
    {
      academicWeekNumber: 40,
      calendarWeekNumber: 22,
      isBlocked: false,
      period: 6,
      startDate: '2027-05-31T00:00:00.000Z',
      endDate: '2027-06-04T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 41,
      calendarWeekNumber: 23,
      isBlocked: false,
      period: 6,
      startDate: '2027-06-07T00:00:00.000Z',
      endDate: '2027-06-11T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 42,
      calendarWeekNumber: 24,
      isBlocked: false,
      period: 6,
      startDate: '2027-06-14T00:00:00.000Z',
      endDate: '2027-06-18T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 43,
      calendarWeekNumber: 25,
      isBlocked: false,
      period: 6,
      startDate: '2027-06-21T00:00:00.000Z',
      endDate: '2027-06-25T23:59:59.000Z',
      weekNumber: 4,
    },
  ],
  '7': [
    {
      academicWeekNumber: 44,
      calendarWeekNumber: 26,
      isBlocked: false,
      period: 7,
      startDate: '2027-06-28T00:00:00.000Z',
      endDate: '2027-07-02T23:59:59.000Z',
      weekNumber: 1,
    },
    {
      academicWeekNumber: 45,
      calendarWeekNumber: 27,
      isBlocked: false,
      period: 7,
      startDate: '2027-07-05T00:00:00.000Z',
      endDate: '2027-07-09T23:59:59.000Z',
      weekNumber: 2,
    },
    {
      academicWeekNumber: 46,
      calendarWeekNumber: 28,
      isBlocked: false,
      period: 7,
      startDate: '2027-07-12T00:00:00.000Z',
      endDate: '2027-07-16T23:59:59.000Z',
      weekNumber: 3,
    },
    {
      academicWeekNumber: 47,
      calendarWeekNumber: 29,
      isBlocked: false,
      period: 7,
      startDate: '2027-07-19T00:00:00.000Z',
      endDate: '2027-07-23T23:59:59.000Z',
      weekNumber: 4,
    },
    {
      academicWeekNumber: 48,
      calendarWeekNumber: 30,
      isBlocked: false,
      period: 7,
      startDate: '2027-07-26T00:00:00.000Z',
      endDate: '2027-07-30T23:59:59.000Z',
      weekNumber: 5,
    },
    {
      academicWeekNumber: 49,
      calendarWeekNumber: 31,
      isBlocked: false,
      period: 7,
      startDate: '2027-08-02T00:00:00.000Z',
      endDate: '2027-08-06T23:59:59.000Z',
      weekNumber: 6,
    },
    {
      academicWeekNumber: 50,
      calendarWeekNumber: 32,
      isBlocked: false,
      period: 7,
      startDate: '2027-08-09T00:00:00.000Z',
      endDate: '2027-08-13T23:59:59.000Z',
      weekNumber: 7,
    },
    {
      academicWeekNumber: 51,
      calendarWeekNumber: 33,
      isBlocked: false,
      period: 7,
      startDate: '2027-08-16T00:00:00.000Z',
      endDate: '2027-08-20T23:59:59.000Z',
      weekNumber: 8,
    },
    {
      academicWeekNumber: 52,
      calendarWeekNumber: 34,
      isBlocked: false,
      period: 7,
      startDate: '2027-08-23T00:00:00.000Z',
      endDate: '2027-08-27T23:59:59.000Z',
      weekNumber: 9,
    },
  ],
};
